const sx = {
  container: {
    py: { xs: 8, md: 10 },
    backgroundColor: '#ffffff', // Fondo general de la sección
  },
  mainTitle: {
    color: '#1A2342',
    fontWeight: 800,
    fontSize: { xs: '2rem', md: '2.5rem' },
    textAlign: 'center',
    mb: { xs: 4, md: 6 },
    textTransform: 'uppercase',
  },
  card: {
    background: 'linear-gradient(180deg, #043857 0%, #09152C 100%)',
    borderRadius: '12px',
    position: 'relative',
    px: 3,
    pb: 4,
    pt: 6, // Más espacio arriba para el ícono y el tag
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'white',
    overflow: 'hidden',
    boxShadow: '0 10px 20px rgba(0,0,0,0.15)',
  },
  numberTag: {
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: '#28B5E1', // Azul claro/cyan de la imagen
    color: 'white',
    fontWeight: 800,
    fontSize: '1.25rem',
    width: '45px',
    height: '45px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottomRightRadius: '12px', // Curva de la pestaña
  },
  iconContainer: {
    mb: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 50,
  },
  cardTitle: {
    fontWeight: 700,
    fontSize: '1rem',
    mb: 2,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  cardDescription: {
    fontSize: '0.875rem',
    lineHeight: 1.6,
    textAlign: 'center',
    color: '#D1D5DB', // Texto ligeramente atenuado para mejor contraste
  },
}

export default sx
